<select #selectModel="ngModel" class="form-control" [ngModel]="assignedTierId" (ngModelChange)="assignPermissionTier($event)" [disabled]="permissionTiers == null || permissionTiers.length == 0 || disablePermissions">
  <option [ngValue]="0">None</option>
  <option [ngValue]="tier.PermissionTierId" *ngFor="let tier of permissionTiers">{{tier.Name}}</option>
</select>
<confirm-delete #confirmModal [confirmationMessage]="confirmationMessage"></confirm-delete>

